const item = (sku, description, quantity) => ({ sku, description, quantity });

export const plasticContainers = [
  {
    slug: "hinged-containers-dual-tab-lock",
    name: "Hinged Containers – Dual Tab Lock",
    category: "plastic-containers",
    description:
      "Classic and versatile hinged containers for hot or cold, wet or dry foods. Available in multiple sizes, compartment configurations, and colors.",
    items: [
      item("V61W", '6"x6" – 1 compartment – White', 250, 24),
      item("V96W", '9"x6" – 1 compartment – White', 150, 22),
      item("V962W", '9"x6" – 2 compartments – White', 200, 28),
      item("V71W", '7"x7" – 1 compartment – White', 150, 22),
      item("V73W", '7"x7" – 3 compartments – White', 150, 22),
      item("V81W", '8"x8" – 1 compartment – White', 150, 25),
      item("V83W", '8"x8" – 3 compartments – White', 150, 25),
      item("V91W", '9"x9" – 1 compartment – White', 150, 28),
      item("V93W", '9"x9" – 3 compartments – White', 150, 28),
      item("V61B", '6"x6" – 1 compartment – Black', 250, 24),
      item("V96B", '9"x6" – 1 compartment – Black', 150, 22),
      item("V81B", '8"x8" – 1 compartment – Black', 150, 25),
      item("V83B", '8"x8" – 3 compartments – Black', 150, 25),
      item("V91B", '9"x9" – 1 compartment – Black', 150, 28),
      item("V93B", '9"x9" – 3 compartments – Black', 150, 28),
      item("V61C", '6"x6" – 1 compartment – Translucent', 250, 26),
      item("V96C", '9"x6" – 1 compartment – Translucent', 150, 23),
      item("V81C", '8"x8" – 1 compartment – Translucent', 150, 32),
      item("V83C", '8"x8" – 3 compartments – Translucent', 150, 32),
      item("V91C", '9"x9" – 1 compartment – Translucent', 150, 36),
      item("V93C", '9"x9" – 3 compartments – Translucent', 150, 36),
    ],
  },
  {
    slug: "clear-hinged-containers-dual-tab-lock",
    name: "Clear Hinged Containers – Dual Tab Lock",
    category: "plastic-containers",
    description:
      "Clear containers for displaying salads, desserts, and other cold foods. Not intended for hot foods.",
    items: [
      item("C53", '5"x5" – 1 compartment', 500, 48),
      item("C57", '6"x6" – 1 compartment', 500, 52),
      item("C90", '8"x8" – 1 compartment', 250, 50),
    ],
  },
  {
    slug: "hinged-containers-center-slide",
    name: "Hinged Containers – Center Slide",
    category: "plastic-containers",
    description:
      "Cost-effective white hinged containers secured by sliding a center tab through a slit.",
    items: [
      item("CS601", '5"x5" – 1 compartment', 250, 18),
      item("CS905", '9"x5" – 1 compartment', 200, 22),
      item("CS801", '8"x8" – 1 compartment', 150, 22),
      item("CS803", '8"x8" – 3 compartments', 150, 22),
      item("CS8001", '9"x8" – 1 compartment', 150, 24),
      item("CS8003", '9"x8" – 3 compartments', 150, 24),
      item("CS901", '9.5"x9.2" – 1 compartment', 150, 30),
      item("CS903", '9.5"x9.2" – 3 compartments', 150, 30),
    ],
  },
  {
    slug: "deli-containers",
    name: "Deli Containers",
    category: "plastic-containers",
    description:
      "Heavy-duty deli containers for soups, sides, and drinks. Matching lids are included.",
    unitLabel: "sets",
    items: [
      item("S8", "8 oz", 240, 23),
      item("S12", "12 oz", 240, 25),
      item("S16", "16 oz", 240, 27),
      item("S24", "24 oz", 240, 32),
      item("S32", "32 oz", 240, 36),
      item("S64", "64 oz", 120, 42),
    ],
  },
  {
    slug: "portion-cups-and-lids",
    name: "Portion Cups & Lids",
    category: "plastic-containers",
    description:
      "Small cups for sauces, salsas, and samples. Listed prices include one case of cups and one case of matching lids; contact ContainX for separate pricing.",
    unitLabel: "sets",
    items: [
      item("P075+L", "0.75 oz", 2500, 23),
      item("P100+L", "1 oz", 2500, 29),
      item("P150+L", "1.5 oz", 2500, 40),
      item("P200+L", "2 oz", 2500, 45),
      item("P325+L", "3.25 oz", 2500, 60),
      item("P400+L", "4 oz", 2500, 65),
      item("P550+L", "5.5 oz", 2500, 70),
    ],
  },
  {
    slug: "round-sealed-containers",
    name: "Round Sealed Containers",
    category: "plastic-containers",
    description:
      "Round containers that seal around the rim, ideal for saucy foods.",
    unitLabel: "sets",
    items: [
      item("R16", "16 oz", 150, 20),
      item("R24", "24 oz", 150, 24),
      item("R32", "32 oz", 150, 26),
      item("R40", "40 oz", 150, 30),
      item("R48", "48 oz", 150, 44),
    ],
  },
  {
    slug: "rectangular-sealed-containers",
    name: "Rectangular Sealed Containers",
    category: "plastic-containers",
    description:
      "Rectangular containers that seal around the rim, ideal for saucy foods.",
    unitLabel: "sets",
    items: [
      item("E12", "12 oz", 150, 15),
      item("E16", "16 oz", 150, 20),
      item("E24", "24 oz", 150, 22),
      item("E26", "26 oz", 150, 23),
      item("E28", "28 oz", 150, 25),
      item("E32", "32 oz", 150, 27),
      item("E38", "38 oz", 150, 30),
    ],
  },
  {
    slug: "heavy-duty-deep-rectangular-containers",
    name: "Heavy-Duty Deep Rectangular Containers",
    category: "plastic-containers",
    unitLabel: "sets",
    description:
      "Heavy-duty, deep rectangular containers that seal around the rim.",
    items: [
      item("TY16", "16 oz", 150, 22),
      item("TY32", "32 oz", 150, 30),
      item("TY58", "58 oz", 150, 48),
    ],
  },
  {
    slug: "compartmental-sealed-containers",
    name: "Compartmental Sealed Containers",
    category: "plastic-containers",
    unitLabel: "sets",
    description:
      "Multi-compartment rectangular containers that seal around the rim.",
    items: [
      item("TY232", "Rectangular – 2 compartments – 32 oz", 150, 28),
      item("TY333", "Rectangular – 3 compartments – 33 oz", 150, 36),
      item("TY339", "Rectangular – 3 compartments – 39 oz", 150, 45),
    ],
  },
  {
    slug: "noodle-bowls",
    name: "Noodle Bowls",
    category: "plastic-containers",
    unitLabel: "sets",
    description: "Round sealed bowls for noodles, soups, and saucy foods.",
    items: [
      item("NB36", "36 oz", 120, 21),
      item("NB42", "42 oz", 120, 22),
      item("NB50", "50 oz", 120, 26),
      item("NB502", "50 oz with divider", 90, 28),
    ],
  },
];
